// extracted by mini-css-extract-plugin
module.exports = {"item":"LoginData_item__e6103","success":"LoginData_success__i_2Py","passwordStrength":"LoginData_passwordStrength__WOWYo"};